import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './idb-project-table.css.lit';
import { idbLogo } from './project-logos';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import '../idb-styled-text/idb-styled-text';
import { classMap } from 'lit/directives/class-map.js';
import { SlotController } from '../../controllers/slot-controller';

type Variants = 'default' | 'clean';

/**
 * The IdbProjectTable component
 * @element idb-project-table
 * @slot - heading - The heading for the table
 * @slot - the default slot for adding idb-project-table-row components
 */
@customElement('idb-project-table')
export class IdbProjectTable extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(
    this, // This, the host element.
    false // To shift or not to shift LightDom nodes to ShadowDOM.
  );

  @property({ type: String, attribute: 'variant' })
  variant: Variants = 'default';

  @state() hasHeadingSlot: boolean;

  firstUpdated(): void {
    this.hasHeadingSlot = this.slots.test('heading');
  }

  render(): TemplateResult {
    const tableClasses = {
      'table-container': true,
      [`variant--${this.variant}`]: true,
    };

    return html`
      <div class=${classMap(tableClasses)}>
        ${
          this.hasHeadingSlot
            ? html`
          <hr />
          <div class="heading-wrapper">
            <slot name="heading"></slot>
            <span class="logos-wrapper">
              ${unsafeSVG(idbLogo)}
            </span>
          </div>
        `
            : null
        }
 
        <div class="table-wrapper">
          <slot></slot>
        </div>
        
      </div>
    `;
  }
}
